export enum HttpActionCodes {
  RedirectToResetPassword = 'RedirectToResetPassword',
}
